import React from 'react'
import { useHistory } from 'react-router-dom'
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded'
import { Button, makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import InternationalizedFormattedText from '../../util/internationalized-formatted-text'

const useStyles = makeStyles(() => ({
  backButton: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  backText: {
    textTransform: 'capitalize',
  },
  backIcon: {
    fontSize: '14px !important',
  },
}))

const BackButton = ({ path }) => {
  const classes = useStyles()
  const history = useHistory()

  const handleRedirect = () => {
    if (!!path) {
      history.push(path)
    } else {
      history.goBack()
    }
  }

  return (
    <Button
      className={classes.backButton}
      variant='text'
      onClick={handleRedirect}
      startIcon={<ArrowBackIosRoundedIcon className={classes.backIcon} />}
    >
      <InternationalizedFormattedText variant='h6' id='back' className={classes.backText} />
    </Button>
  )
}

BackButton.propTypes = {
  path: PropTypes.string,
}

export default BackButton
